import Summary from './Summary.vue';

export default Summary;
